import { render, staticRenderFns } from "./QuitarForm.vue?vue&type=template&id=06c59d9c&scoped=true"
import script from "./QuitarForm.vue?vue&type=script&lang=js"
export * from "./QuitarForm.vue?vue&type=script&lang=js"
import style0 from "./QuitarForm.vue?vue&type=style&index=0&id=06c59d9c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06c59d9c",
  null
  
)

export default component.exports